export default __webpack_public_path__ + "static/media/lastframe-sm-2x.1bdea581.jpg";